// @flow
import { ContratosActionTypes } from './constants';

type ContratosAction = { type: string, payload: {} | string };

// common success
export const contratosApiResponseSuccess = (actionType: string, data: any): ContratosAction => ({
    type: ContratosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const contratosApiResponseError = (actionType: string, error: string): ContratosAction => ({
    type: ContratosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getContrato = (id: string): ContratosAction => ({
    type: ContratosActionTypes.GET_CONTRATO,
    payload: { id },
});

export const listContratos = (): ContratosAction => ({
    type: ContratosActionTypes.LIST_CONTRATOS,
    payload: {},
});

export const addContrato = (contrato:any): ContratosAction => ({
    type: ContratosActionTypes.CREATE_CONTRATO,
    payload:contrato
})

export const updateContrato = (contrato:any): ContratosAction => ({
    type:ContratosActionTypes.UPDATE_CONTRATO,
    payload:contrato
})

export const deleteContrato = (id:string): ContratosAction => ({
    type:ContratosActionTypes.DELETE_CONTRATO,
    payload:{id}
})


export const resetContratos = (): ContratosAction => ({
    type: ContratosActionTypes.RESET,
    payload: {},
});
export const resetContrato = (): ContratosAction => ({
    type: ContratosActionTypes.RESET_CONTRATO,
    payload: {},
});

